

import React from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import { Accordion, AccordionSummary, AccordionDetails, Icon } from '@mui/material';

// Components
import ConnectionHistory from './ConnectionHistory';
import OdometerEngineHours from './OdometerEngineHours';
import VerifyLocation from './VerifyLocation';
import Summary from './Summary'

const Process = ({ expanded, formData, setFormData, resetDevice, openChat }) => {
    const { messages } = useIntl();

    //Redux States
    const {
        installationValidation,
        simCardValidation,
        simCardSessionValidation,
        locationValidation,
        odometerAndEngineOdometerValidation,
        rebootGeneralDevice,
        rebootVidfleetDevice,
        unitDetail,
        config
    } = useSelector(state => state.troubleshootDeviceRedux);

    const accordionData = [
        {
            id: 1,
            title: messages['troubleshootDevice_connectionHistory'],
            enabled: true,
            icon: {
                name: (installationValidation?.error || simCardValidation?.error || simCardSessionValidation?.error) ? "error" : (installationValidation?.data && simCardValidation?.data && simCardSessionValidation?.data) ? "check_circle" : "radio_button_unchecked",
                color: (installationValidation?.error || simCardValidation?.error || simCardSessionValidation?.error) ? "#FF6624" : (installationValidation?.data && simCardValidation?.data && simCardSessionValidation?.data) ? "#66BB6A" : "#252525"
            },
            component: <ConnectionHistory installationValidation={installationValidation} simCardValidation={simCardValidation} openChat={openChat} />
        },
        {
            id: 2,
            title: messages['troubleshootDevice_location'],
            enabled: true,
            icon: {
                name: locationValidation?.error || (rebootGeneralDevice && !rebootGeneralDevice?.result) || (rebootVidfleetDevice && !rebootVidfleetDevice?.result) ? "error" : locationValidation?.data || (rebootGeneralDevice && rebootGeneralDevice?.result) || (rebootVidfleetDevice && rebootVidfleetDevice?.result) ? "check_circle" : "radio_button_unchecked",
                color: locationValidation?.error || (rebootGeneralDevice && !rebootGeneralDevice?.result) || (rebootVidfleetDevice && !rebootVidfleetDevice?.result) ? "#FF6624" : locationValidation?.data || (rebootGeneralDevice && rebootGeneralDevice?.result) || (rebootVidfleetDevice && rebootVidfleetDevice?.result) ? "#66BB6A" : "#252525"
            },
            component: <VerifyLocation resetDevice={resetDevice} openChat={openChat} />
        },
        {
            id: (unitDetail?.deviceModel?.odometerEnable || unitDetail?.deviceModel?.hoursEnable) ? 3 : null,
            title: messages['troubleshootDevice_OdometerEngineHours'],
            enabled: unitDetail?.deviceModel?.odometerEnable || unitDetail?.deviceModel?.hoursEnable || false,
            icon: {
                name: odometerAndEngineOdometerValidation?.error ? "error" : odometerAndEngineOdometerValidation?.data || config?.id ? "check_circle" : "radio_button_unchecked",
                color: odometerAndEngineOdometerValidation?.error ? "#FF6624" : odometerAndEngineOdometerValidation?.data || config?.id ? "#66BB6A" : "#252525"
            },
            component: <OdometerEngineHours formData={formData} setFormData={setFormData} />
        },
        {
            id: (unitDetail?.deviceModel?.odometerEnable || unitDetail?.deviceModel?.hoursEnable) ? 4 : 3,
            title: messages['troubleshootDevice_summary'],
            enabled: true,
            icon: {
                name: expanded === 4 ? "check_circle" : "radio_button_unchecked",
                color: expanded === 4 ? "#66BB6A" : "#252525"
            },
            component: <Summary openChat={openChat} />
        }
    ];

    return (
        <div>
            {accordionData.filter((item) => item.enabled).map((item, index) => (
                <Accordion key={index} expanded={expanded === item.id}>
                    <AccordionSummary aria-controls={`step${item.id}-content`} id={`step${item.id}-header`}>
                        <div className="troubleshoot-device-accordion">
                            <span className="troubleshoot-device-accordion-title">{item.title}</span>
                            <Icon style={{ marginRight: 5, color: item.icon.color }}>{item.icon.name}</Icon>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        {item.component}
                    </AccordionDetails>
                </Accordion>
            ))}
        </div>
    );
}

export default Process;